const voucherCode = (state = "", action) => {
    switch(action.type) {
        case 'voucherCode':
            return action.payload;
        default:
            return state;
    }
}

export default voucherCode;